export const socials = [
    {
        title: 'Facebook',
        url: '/',
    },
    {
        title: 'LinkedIn',
        url: '/',
    },
    {
        title: 'YouTube',
        url: '/',
    },
    {
        title: 'X',
        url: '/',
    },
    {
        title: 'Instagram',
        url: '/',
    },
];
export const legal = [
    {
        title: 'Aansprakelijkheid',
        url: '/',
    },
    {
        title: 'Privacy statement',
        url: '/',
    },
    {
        title: 'Cookies wijzigen',
        url: '/',
    },
    {
        title: 'Lidmaatschap opzeggen',
        url: '/',
    },
    {
        title: 'Algemene voorwaarden',
        url: '/',
    },
];
export const groups = [
    {
        title: 'Regel het snel',
        links: [
            {
                title: 'Contact met de ANWB',
                url: '/',
            },
            {
                title: 'ANWB Alarmcentrale',
                url: '/',
            },
            {
                title: 'Plan je route',
                url: '/',
            },
        ],
    },
    {
        title: 'Altijd actueel',
        links: [
            {
                title: 'Acties en aanbiedingen',
                url: '/',
            },
            {
                title: 'Lees de kampioen',
                url: '/',
            },
            {
                title: 'Lees onze nieuwsbrieven',
                url: '/',
            },
        ],
    },
    {
        title: 'Over ANWB',
        links: [
            {
                title: 'Werken bij de ANWB',
                url: '/',
            },
            {
                title: 'Vereniging en bedrijf',
                url: '/',
            },
            {
                title: 'Voor de pers',
                url: '/',
            },
        ],
    },
    {
        title: 'Voor onderweg',
        links: [
            {
                title: '24/7 Pechhulp',
                url: '/',
            },
            {
                title: 'Bekijk de ANWB Apps',
                url: '/',
            },
            {
                title: 'Luster ANWB Podcasts',
                url: '/',
            },
        ],
    },
];
